export default "__VITE_ASSET__23384dce__"